import { useEffect, useCallback, useRef } from "react";
import { Backdrop } from "@mui/material";
import closeIcon from "components/icons/cross-black.svg";
import "./style/Popup.scss";

interface IPopupProps {
  onClose?: () => void;
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  [x:string]: any;
}

export const Popup = ({ onClose, isOpen, title, children, ...restProps }: IPopupProps) => {
  const popupRef = useRef<HTMLInputElement>(null);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const closePopup = (e: React.MouseEvent) => {
    if (popupRef.current === e.target && onClose) {
      onClose();
    }
  };

  return (
    <Backdrop
      open={isOpen}
      onClick={closePopup}
      ref={popupRef}
      sx={{
        zIndex: 30
      }}
      {...restProps}
    >
      <div className="Popup">
        <div className="Popup-Header">
          <h4>{title}</h4>
          {onClose && <button onClick={onClose}>
            <img src={closeIcon} alt="close popup" />
          </button>}
        </div>
        <div className="Popup-Content">
          {children}
        </div>
      </div>
    </Backdrop>
  );
};
